import { FilterMenuConfig } from '../../types/filter.type';

export const UPLOAD_FILTERS: FilterMenuConfig = {
  filters: [
    {
      type: 'checkbox',
      data: [],
    },
  ],
};
